import core from './core';
import boards from './boards';

export default {
  ...core,
  ...boards,
};
